import React from "react";

import paperPlanIcon from "../../../assets/images/paper-plane.png";

import ModalHolder from "../../molecules/ModalHolder";

import { H3, P } from "../../atoms/Texts";
import { PrimaryButton } from "../../atoms/Buttons";

const InitiativeSuccessModal = ({ closeModal, message1, message2 }) => {
  return (
    <ModalHolder closeModal={closeModal}>
      <div className="pb-16">
        <img
          src={paperPlanIcon}
          alt="request sent"
          className="h-24 w-24 mx-auto mb-6"
        />
        <H3 color="#22202D" fontFamily="medium" className="text-center">
          Request sent
        </H3>
        <P color="#7D7B96" fontSize="14px" className="text-center mt-6  mx-auto">
          {message1}
        </P>

        <P color="#7D7B96" fontSize="14px" className="text-center  mx-auto mt-4">
          {message2}
        </P>

        <div className="flex justify-center mt-6">
          <PrimaryButton.Light onClick={closeModal}>
            Back to Initiatives Home
          </PrimaryButton.Light>
        </div>
      </div>
    </ModalHolder>
  );
};

export default InitiativeSuccessModal;
